export default __webpack_public_path__ + "static/summit_stars_4_6-3b16bc523c365b420fffa7bcd70b61dc.svg";